import { render, staticRenderFns } from "./questionSelect.vue?vue&type=template&id=2f2aab98&scoped=true"
import script from "./questionSelect.vue?vue&type=script&lang=js"
export * from "./questionSelect.vue?vue&type=script&lang=js"
import style0 from "./questionSelect.vue?vue&type=style&index=0&id=2f2aab98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2aab98",
  null
  
)

export default component.exports